import React, { Component } from 'react';
import NewHeaderComponent from '../new-header/new-header.component';
import DoorStepComponent from '../doorstep/doorstep.component';
import FlightDetailsComponent from '../flight-details/flight-details.component';
import ProhibitedItemsComponent from '../prohibited-items/prohibited-items.component';
import SecurityDeclarationComponent from '../security-declaration/security-declaration.component';
import ExcessOverweightOversizeBags from '../excess-overweight-oversize-bags/excess-overweight-oversize-bags';
import PreAcceptanceCompleteComponent from '../pre-acceptance-complete/pre-acceptance-complete';
import multiLang from '../../static-data/data';
import languages from '../../enum/language.enum';

interface IState {
  status: number;
  progressBar: number;
  mergedQuestions: any;
  language: string;
  languageCode: string;
}

interface IProps {
  language: string;
  languageCode: string;
  trackingData: any;
  handleLanguageChange: any;
  passengerRules: any;
  isHubDrop?: boolean;
}

export class PreAcceptanceComponent extends Component<IProps, IState> {
  constructor(props: any) {
    super(props);
    this.state = {
      status: 1,
      progressBar: 0,
      mergedQuestions: [],
      language: '',
      languageCode: 'en',
    };

    this.statusHandler = this.statusHandler.bind(this);
  }

  componentDidMount() {
    this.setLanguage();
    // Merge function
    function mergeArrays(array1, array2) {
      const mergedArray = [];

      // Merge and set all answers to "Yes" for securityQuestions
      array1.forEach((question) => {
        const mergedQuestion = {
          question: question.questionText,
          answer: 'No',
        };
        mergedArray.push(mergedQuestion);
      });

      // Merge excessBagQuestionAnswers
      array2.forEach(({ question, answer }) => {
        const mergedQuestion = {
          question: question.message,
          answer: answer,
        };
        mergedArray.push(mergedQuestion);
      });

      return mergedArray;
    }
    // Call merge function with API response arrays
    const merged = mergeArrays(this.props.trackingData.preAcceptance.securityQuestions, this.props.trackingData.preAcceptance.excessBagCharge.excessBagQuestionAnswers);
    this.setState({ mergedQuestions: merged });
  }

  private setLanguage() {
    const code = this.props.trackingData.trackingBookingDetails && this.props.trackingData.trackingBookingDetails.languageCode || 0;
    this.handleLanguageChange(languages[code]);
  }

  handleLanguageChange(langCode: string) {
    const code = langCode === 'en' ? '' : `_${langCode}`;

    console.log(langCode, code);

    this.setState({
      languageCode: langCode,
      language: code,
    });
  }

  statusHandler = (status) => {
    console.log(status);
    if (status >= 2 && status <=  4) {
      this.setState((prevState) => ({
        progressBar: prevState.progressBar + 33,
      }));
    }
    this.setState({ status });
  };

  render() {
    const bannedItem = this.props.trackingData.preAcceptance?.bannedItemsImageURL;
    const flightDetails = this.props.trackingData?.flightDetails;
    const securityQuestions = this.props.trackingData.preAcceptance?.securityQuestions;
    const bookingJourneyReference = this.props.trackingData.bookingJourneyReference;
    const statementContent = this.props.trackingData.preAcceptance?.excessBagCharge.statementContent;
    const bookerUserId = this.props.trackingData.preAcceptance?.bookerUserId;
    const passengerRules = this.props.passengerRules;
    const isHubDrop = this.props.isHubDrop;

    const showPreAcceptanceComponent = (status) => {
      switch (status) {
        case 1: {
          return (
            <>
              <DoorStepComponent multiLang={multiLang} language={this.state.language} languageCode={this.state.languageCode} handleLanguageChange={(val) => this.handleLanguageChange(val)} statusHandler={this.statusHandler} />
              <FlightDetailsComponent multiLang={multiLang} language={this.state.language} languageCode={this.state.languageCode} handleLanguageChange={(val) => this.handleLanguageChange(val)} step={1} statusHandler={this.statusHandler} flightDetails={flightDetails} />
            </>
          );
        }
        case 2: {
          return (<ProhibitedItemsComponent multiLang={multiLang} language={this.state.language} languageCode={this.state.languageCode} handleLanguageChange={(val) => this.handleLanguageChange(val)} step={2} bannedItem={bannedItem} statusHandler={this.statusHandler} />
          );
        }
        case 3: {
          return (<SecurityDeclarationComponent multiLang={multiLang} language={this.state.language} languageCode={this.state.languageCode} handleLanguageChange={(val) => this.handleLanguageChange(val)} step={3} statusHandler={this.statusHandler} securityQuestions={securityQuestions} />);
        }
        case 4: {
          return (<ExcessOverweightOversizeBags trackingData={this.props.trackingData} multiLang={multiLang} language={this.state.language} languageCode={this.state.languageCode} handleLanguageChange={(val) => this.handleLanguageChange(val)} step={4} statementContent={statementContent} statusHandler={this.statusHandler} />);
        }
        case 5: {
          return (<PreAcceptanceCompleteComponent isHubDrop={isHubDrop} passengerRules={passengerRules} multiLang={multiLang} language={this.state.language} languageCode={this.state.languageCode} handleLanguageChange={(val) => this.handleLanguageChange(val)} mergedQuestions={this.state.mergedQuestions} bookingJourneyReference={bookingJourneyReference} bookerUserId={bookerUserId} trackingData={this.props.trackingData} statusHandler={this.statusHandler} />);
        }
        default: {
          return (
            <>
              <DoorStepComponent multiLang={multiLang} language={this.state.language} languageCode={this.state.languageCode} handleLanguageChange={(val) => this.handleLanguageChange(val)} statusHandler={this.statusHandler} />
              <FlightDetailsComponent multiLang={multiLang} language={this.state.language} languageCode={this.state.languageCode} handleLanguageChange={(val) => this.handleLanguageChange(val)} step={1} statusHandler={this.statusHandler} flightDetails={flightDetails} />
            </>
          );
        }
      }
    };

    return (
      <div className='portrPreStep'>
        <NewHeaderComponent languageCode={this.state.languageCode} handleLanguageChange={(val) => this.handleLanguageChange(val)} />
        <div className='preStep__content'>
          {this.state.status >= 2 && this.state.status <= 4 && (
            <div className='progressBar'>
              <span
                style={{ width: this.state.progressBar + '%' }}
              ></span>
            </div>
          )}
          {showPreAcceptanceComponent(this.state.status)}
        </div>
      </div>
    );
  }
}

export default PreAcceptanceComponent;



// WEBPACK FOOTER //
// ./src/components/pre-acceptance/pre-acceptance.component.tsx